import NFTHeader from "@/components/NFTHeader";
import Error from "@/view/Error";
import React, {useEffect, useReducer, useRef} from "react";
import ShopEditBox from "@/view/ape/PayPage/component/ShopEditBox";
import {useLocation, useNavigate} from "react-router-dom";
import {getUrlAllParams} from "@/utils/publicFun";
import TotalInfoBox from "@/view/ape/PayPage/component/TotalInfoBox";
import PayTypeSelect from "@/view/ape/PayPage/component/PayTypeSelect";
import BottomBtn from "@/view/supperzzle/powerPay/components/BottomBtn";
import {Toast} from "antd-mobile";
import {checkNotpay, getTicketPrepaid, getUserInfo} from "@/api/projectManager_self";
import {hideLoading, showLoading} from "@/components/loading";
import './index.scss'
import Service from '../service'
import powerIcon from '@/assets/img/supperzzle/powerIcon3.png'

const PowerPay = () => {
  const navigate = useNavigate()
  //获取参数
  const {search} = useLocation()
  const param = getUrlAllParams(search.slice(1));
  const [state, dispath] = useReducer((state,action)=> {
    //数据处理
    if(JSON.stringify(state) != JSON.stringify(action)) {
      return {
        ...state,
        ...action
      }
    }
    return state
  }, {
    // 设置state初始值
    errorContext:'',
    userInfo: {},
    payDetail:{},
    payType:'',
    salePrice: 0,
    totalPrice: 0,
    count: 1,
  });

  const notPayOrder = useRef(false)
  const verifyRealName = useRef(true)

  useEffect(()=>{
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.setTitle('订单支付')
      window.JsBridge.verifyRealName("请先实名认证").then((res)=> {
        verifyRealName.current = !!res?.result
      })
    }
    loadPageData()

  },[])
  //获取用户信息
  const queryUserInfo = async () => {
    const {code, msg, data} = await getUserInfo();
    if (code !== '000000') throw msg;
    return data;
  }
  //获取支付信息
  const getPayDetail = async () => {
    const params = {
      activityCode: Service.activityCode,
      source: 'app',
      productId: 1,  // 1代表体力
    };
    const {code, msg, data} = await getTicketPrepaid(params);
    if (code !== '000000') throw msg;
    return data?.info;
  }
  //有无待支付订单
  const checkIsHasNotPay = async (collectionType) => {
    const {code, msg, data} = await checkNotpay({collectionType: collectionType || ''});
    if (code !== '000000') throw msg;
    if (data?.notPayOrderCnt) {
      Toast.show("您有待付款的订单，请先完成上次订单")
      notPayOrder.current = true
    }
  }
  const loadPageData = async () => {
    try {
      showLoading();
      const [userInfo, payDetail] = await Promise.all([queryUserInfo(), getPayDetail()]);
      // await checkIsHasNotPay(payDetail?.collectionType);
      hideLoading();
      dispath({
        userInfo: userInfo ||{},
        payDetail: {
          defRepeatStr: payDetail?.defRepeatStr,
          collectionName: payDetail?.productName,
          price: payDetail?.price,
          maxValue: payDetail?.maxNum,
          imageBg: powerIcon,
        }
      })

    } catch (error) {
      hideLoading();
      if(process.env.NODE_ENV !== 'development') {
        dispath({errorContext: error})
      }
      Toast.show(error);
    }
  }

  const backToGame = (result) => {
    window.localStorage.setItem('buyPowerOrderNo', result?.data?.outTradeNo)
    if(window.JsBridge){
      window.JsBridge.back()
    }else{
      navigate(-1)
    }
  }
  const otherBackGame = () => {
    if(window.JsBridge){
      window.JsBridge.back()
    }else{
      navigate(-1)
    }
  }

  const renderBody = () => {
    return (
      <div className="powerPayPage--body">
        <div className="powerPayPage-body-content">
          <ShopEditBox userInfo={state.userInfo}
                       payDetail={state.payDetail}
                       maxCount={10}
                       showPurchaseMax={true}
                       noDiff={true}
                       onPriceChange={(totalPrice, count)=> {
                         dispath({
                           count: count,
                           totalPrice: totalPrice
                         })

                       }}
          />
          <TotalInfoBox userInfo={state.userInfo}
                        payDetail={{...state.payDetail, count: state.count, totalPrice: state.totalPrice}}/>
          <PayTypeSelect onChange={(pay)=>dispath({payType: pay.payType})}/>
        </div>
        <div className="powerPayPage-bottom">
          <BottomBtn
            userInfo={state.userInfo}
            payDetail={{...state.payDetail, count: state.count, totalPrice: state.totalPrice}}
            param={param}
            verifyRealName={verifyRealName.current}
            notPayOrder={notPayOrder.current}
            payWay={state.payType}
            callback={(result) => {
              if(result.code === 'success') {
                backToGame(result)
              }else if((result.code === 'pending')){
                // 不等待支付结果，直接跳转
                backToGame(result)
              }else {
               otherBackGame()
              }
            }}
          />
        </div>
      </div>
    )
  }
  return (
    <div className="powerPayPage">
      {
        !window.JsBridge.hasWebViewBridge() &&
        <NFTHeader midText="订单支付" bgColor="white"/>
      }
      {/*<button onClick={backToGame}>test</button>*/}
      {
        state.errorContext ? <Error context={state.errorContext}/>:
          renderBody()
      }
    </div>
  )
}
export default PowerPay